import axios from '_u/axios'

// 资讯列表
export const notifyList = (body) => {
    return axios.post('api/notify/info/list', body)
}

// 资讯列表-不过滤房间
export const notifyGlobalList = (body) => {
    return axios.post('api/notify/info/list2', body)
}

// 查询资讯详情
export const notifyView = (id) => {
    return axios.post('api/notify/info/view', { id })
}

// 新增资讯
export const notifyAdd = (body) => {
    return axios.post('api/notify/info/add', body)
}

// 修改资讯
export const notifyUpdate = (body) => {
    return axios.post('api/notify/info/update', body)
}

// 删除
export const notifyDelete = (id) => {
    return axios.post('api/notify/info/delete', { id })
}

// 发布取消
export const notifyPublish = (id) => {
    return axios.post('api/notify/info/publish', { id })
}

// 通知列表
export const msgList = (body) => {
    return axios.post('api/notify/info/notifyList', body)
}

// 通知历史列表
export const msgHistoryList = (body) => {
    return axios.post('api/push/push/list', body)
}

// 新增发送任务
export const pushAdd = (body) => {
    return axios.post('api/push/push/add', body)
}

// 执行发送任务
export const startPush = (body) => {
    return axios.post('api/push/push/startPush', body)
}
